module.exports = __webpack_public_path__ + "media/images/flags/cx-6d8f20baaec067acea1429e89988ed1f.svg";